import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b94322b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#999"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0  8px"} }, "-", -1))
const _hoisted_5 = {
  key: 2,
  style: {"color":"#999"}
}
const _hoisted_6 = { key: 3 }


import {NumberRangeFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberRangeTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data[_ctx.widget.minPropName] === undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "未填写"))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.data[_ctx.widget.minPropName]), 1)),
    _hoisted_4,
    (_ctx.data[_ctx.widget.maxPropName] === undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "未填写"))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.data[_ctx.widget.maxPropName]), 1))
  ]))
}
}

})